import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import type { UserSettings, User } from '../../domain/user';
import { queryClient } from '../../queryClient';

import { userApi } from './api';
import userQueryKey from './userQueryKey';

const mutationFn = async (settings: Partial<UserSettings>): Promise<void> => await userApi.saveUserSettings(settings);

const handleSuccess = (_: void, settings: Partial<UserSettings>) => {
  queryClient.setQueryData(userQueryKey.userInfo(), (oldData: User) => {
    if (!oldData) {
      return;
    }
    return {
      ...oldData,
      userSettings: {
        ...oldData.userSettings,
        ...settings,
      },
    };
  });
};

export const mutateUserSettings = async (settings: UserSettings) => {
  try {
    await mutationFn(settings);
    handleSuccess(undefined, settings);
  } catch (error) {
    console.error('Error saving settings:', error);
  }
};

export const useUserSettingsMutation = (props?: {
  onSuccess?: () => void;
}): UseMutationResult<void, void, Partial<UserSettings>> => {
  return useMutation({
    mutationKey: ['update-settings'],
    mutationFn,
    onSuccess: (data, variables) => {
      handleSuccess(data, variables);
      props?.onSuccess?.();
    },
  });
};
